import { connect } from 'react-redux'
import LessonOverviewSlideEditDialog from './edit-dialog.jsx'
import { updateSlide } from '../../../../stores/presentation/presentation.actions'
import {
  getSlide,
  getUpdateSlideRequest
} from '../../../../stores/presentation/presentation.selectors'
import { errorHandler } from 'pobble-components/dist/error-handler'
import { getEditSlideDialog } from '../../../pages/lesson/builder/redux/builder.selectors.js'
import { closeEditSlideDialog } from '../../../pages/lesson/builder/redux/builder.actions.js'

const mapStateToProps = state => {
  const edistSlideDialog = getEditSlideDialog(state)
  const slide = getSlide(state, edistSlideDialog.slideId)
  if (!slide) return { modalOpened: false }
  const updateSlideRequest = getUpdateSlideRequest(state, slide.id)
  return {
    updating: updateSlideRequest.pending,
    modalOpened:
      edistSlideDialog.opened && edistSlideDialog.type === 'LessonOverview',
    body: slide.body,
    id: slide.id
  }
}

const mapDispatchToProps = dispatch => ({ dispatch })

const mergeProps = (stateProps, { dispatch }, ownProps) => ({
  ...ownProps,
  ...stateProps,
  onSubmit: values =>
    dispatch(
      updateSlide(stateProps.id, 'LearningObjective', { body: values.body })
    ).catch(errorHandler),
  onClose: () => dispatch(closeEditSlideDialog())
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(LessonOverviewSlideEditDialog)
